import { ProductIcon } from "@/components/ProductIcon";

interface HelpTooltipProps {
  text: string;
  productIcon?: string;
  productLabel?: string;
  side?: "right" | "bottom";
}

export function HelpTooltip({
  text,
  productIcon,
  productLabel,
  side = "right",
}: HelpTooltipProps) {
  const placement =
    side === "bottom"
      ? "left-1/2 top-full mt-2 -translate-x-1/2"
      : "left-full top-1/2 ml-2 -translate-y-1/2";

  return (
    <span className="relative group/help shrink-0 ml-auto">
      <button
        type="button"
        className={
          productIcon
            ? "flex items-center gap-1 px-2 py-1 rounded-full border border-amber-500/30 bg-amber-500/10 cursor-help hover:border-amber-500/50 transition-colors"
            : "ml-auto w-[22px] h-[22px] p-0 rounded-full border-[1.5px] border-amber-500/50 bg-amber-500/10 flex items-center justify-center cursor-help shrink-0"
        }
        aria-label={text}
      >
        {productIcon ? <ProductIcon name={productIcon} className="w-3.5 h-3.5 rounded-sm" /> : null}
        <span
          className="text-[11px] font-bold text-amber-400"
          style={{ fontFamily: "Arial, sans-serif" }}
        >
          ?
        </span>
      </button>
      <span
        role="tooltip"
        className={`pointer-events-none absolute z-50 hidden group-hover/help:block group-focus-within/help:block w-max max-w-xs rounded-md border border-zinc-700 bg-zinc-800 px-2 py-1.5 text-xs text-white shadow-lg ${placement}`}
      >
        {productLabel ? (
          <>
            <span className="block text-[11px] font-semibold text-ink-50 uppercase tracking-wide mb-1">
              {productLabel}
            </span>
            <span>{text}</span>
          </>
        ) : (
          text
        )}
      </span>
    </span>
  );
}
